export default function isUndefined(value) {
    return typeof value === 'undefined';
}
